import { Divider, PageHeadline } from 'components/elements';
import { useFind } from 'components/hooks';
import { ReadOnly } from 'components/modules';
import fp from 'lodash/fp';
import { useTranslation } from 'react-i18next';
import { useMount } from 'react-use';
import { JournalActivityResources } from 'services/resources/catalogs/journal-activity';
import { IReadOnlyResource } from 'services/resources/catalogs/types.d';

export const JorunalActivityPage: React.FC = (): JSX.Element => {
  const [state, onFind] = useFind<IReadOnlyResource>(JournalActivityResources);

  useMount(() => onFind());

  const { t } = useTranslation('common');

  return (
    <>
      <PageHeadline
        quote={t('page.read-only.quote')}
        title={t('page.journal-activity.title')}
      />

      <Divider />

      <ReadOnly data={fp.get(['value', 'results'])(state)} m={8} />
    </>
  );
};
